module.exports = "i {\n  padding-right: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/demo/connect-page/connect-page.component.sass
// module id = ./src/app/demo/connect-page/connect-page.component.sass
// module chunks = main